import {
  buildRichTooltip,
  RICH_TOOLTIP_CLASS,
  tooltipField,
  tooltipText,
  tooltipTitle,
} from "../../../../../../../_shared/_logic/rich-tooltips"

export const SETTINGS_ACTION_TOOLTIP_CLASS = RICH_TOOLTIP_CLASS

type SettingsTooltipParts = {
  title: string
  action: string
  effect?: string
  hint?: string
}

const actionTooltip = ({ title, action, effect, hint }: SettingsTooltipParts): string =>
  buildRichTooltip([
    tooltipTitle(title),
    tooltipField("Was passiert", action),
    tooltipField("Auswirkung", effect),
    tooltipText(hint),
  ])

export const settingsActionTooltips = {
  restoreOrderTypeDefaults: actionTooltip({
    title: "Auftragstyp-Defaults wiederherstellen",
    action: "Stellt die Standard-Auftragstypen für diese Organisation wieder her.",
    effect:
      "Standardtypen werden auf ihre Standardwerte zurückgesetzt; individuelle Auftragstypen werden entfernt.",
  }),
  deleteOrderType: actionTooltip({
    title: "Auftragstyp löschen",
    action: "Löscht diesen Auftragstyp aus den Organisationseinstellungen.",
    effect:
      "Bestehende Aufträge behalten ihre gespeicherten Daten, neue Aufträge können diesen Typ danach nicht mehr auswählen.",
  }),
  deleteSignature: tooltipText("Neue Briefe werden ohne diese Unterschrift erstellt.")!,
  replaceSignature: tooltipText("Neue Briefe verwenden die neue Unterschrift.")!,
  downloadAushang: tooltipText(
    "Allgemeinen Aushang ohne auftragsspezifische Daten als PDF herunterladen.",
  )!,
} as const
